/*
Aqui são realizadas as importações das variáveis de ambiente
*/
const config = {
    port: process.env.REACT_APP_PORT,
    apiUrl: process.env.REACT_APP_API_URL
};

export default config;